import view from 'bundle-text:../dom/signOut.html';
import app from './app';

export default () => {
  const content = document.createElement('div');

  content.classList.add(
    'align-items-center',
    'd-flex',
    'justify-content-center',
    'w-100',
  );
  content.innerHTML = view;

  document.title = `${app.run.settings.view.signOut.pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;

  localStorage.removeItem('token');
  setInterval(() => {
    window.location = '/';
  }, 1000);

  return content;
};
